import React, { ReactNode, useContext } from 'react';

import { StyleSheet, View } from 'react-native';
import DyteClient from '@dytesdk/web-core';
import { DyteI18n, useLanguage } from '../lib/lang';
import DyteText from './DyteText';
import { Peer } from '../types/dyte-client';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  participant,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isScreenshare = false,
  maxLength = 20,
  meeting,
  size = 'sm',
  t,
  children,
}: {
  participant: Peer;
  meeting?: DyteClient;
  isScreenshare?: boolean;
  maxLength?: number;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  t?: DyteI18n;
  children?: ReactNode;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const defaultLang = useLanguage();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  t = t ?? defaultLang;
  const styles = StyleSheet.create({
    container: {
      flexDirection: 'row',
      padding: 4,
      backgroundColor: colors.background[900],
      borderRadius: 4,
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: 160 + maxLength,
      overflow: 'hidden',
    },
    childStyle: {
      minWidth: 35,
      justifyContent: 'center',
      alignItems: 'center',
    },
  });
  return (
    <View style={styles.container}>
      <View style={styles.childStyle}>{children}</View>
      {(!participant || !meeting) && (
        <DyteText size={size}>Invalid User</DyteText>
      )}
      {meeting && participant && (
        <DyteText size={size}>
          {participant.name}{' '}
          {participant.id === meeting?.self?.id ? ' (you)' : ''}
        </DyteText>
      )}
    </View>
  );
}
